import { Card, CardContent, Grid, IconButton, Button } from "@mui/material";
import { Delete } from "@mui/icons-material";
import theme from "../../../static/styles/theme";

const MobileCardOrderList = ({ items, handleAddRow, handleRemoveRow, getItemRow }) => {
    return (
        <div>
            {items.map((item, index) => (
                <Card
                    key={index}
                    sx={{
                        mb: 2,
                        borderRadius: "8px",
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                        position: "relative",
                    }}
                >
                    {/* Delete button top right */}
                    <IconButton
                        onClick={() => handleRemoveRow(index)}
                        sx={{ position: "absolute", top: 5, right: 4 }}
                    >
                        <Delete />
                    </IconButton>

                    <CardContent>
                        <Grid container spacing={1}>
                            {getItemRow(index, true).map((cell, idx) => (
                                <Grid item xs={12} key={idx}>
                                    {cell}
                                </Grid>
                            ))}
                        </Grid>
                    </CardContent>
                </Card>
            ))}

            {/* Add More Items Button */}
            <Button
                variant="outlined"
                onClick={handleAddRow}
                sx={{
                    width: "100%",
                    borderRadius: "8px",
                    mt: 2,
                    border: `1px dashed ${theme.themeOrange}`,
                    color: theme.themeOrange,
                }}
            >
                + Add More Items
            </Button>
        </div>
    );
};

export default MobileCardOrderList;
